export const CASE_STATUS_VALUES = [
  'CASE_STAGE_1_CONFIRMING',
  'CASE_STAGE_1_REVIEWING',
  'CASE_STAGE_1_IN_PROGRESS',
  'CASE_STAGE_1_PRODUCT_REQUESTING',
  'CASE_STAGE_1_COMPLETED',
  'CASE_STAGE_2_CONFIRMING',
  'CASE_STAGE_2_REVIEWING',
  'CASE_STAGE_2_IN_PROGRESS',
  'CASE_STAGE_2_PRODUCT_REQUESTING',
  'CASE_STAGE_2_COMPLETED',
  'CASE_STAGE_3_CONFIRMING',
  'CASE_STAGE_3_REVIEWING',
  'CASE_STAGE_3_IN_PROGRESS',
  'CASE_STAGE_3_PRODUCT_REQUESTING',
  'CASE_COMPLETED',
  'CASE_REJECTED',
]

function callTranslate(vm, key, fallback) {
  try {
    const translated = vm && typeof vm.$st === 'function'
      ? vm.$st(key)
      : vm && typeof vm.$t === 'function'
        ? vm.$t(key)
        : ''
    if (translated && translated !== key) return translated
  } catch (e) {
    // fall through
  }
  return fallback
}

export function caseStatusKey(status) {
  return `case.status.${String(status || '').trim().toLowerCase()}`
}

export function casePriorityKey(priority) {
  const n = Number(priority)
  if (n === 0) return 'case.priority.low'
  if (n === 1) return 'case.priority.medium'
  if (n === 2) return 'case.priority.high'
  return 'case.priority.unknown'
}

const CASE_STAGE_TITLE_KEYS = {
  1: 'case.progress.stage_basic_design',
  2: 'case.progress.stage_application',
  3: 'case.progress.stage_detail_design',
}

/** 依頼内容＝構造計算の案件か（一覧の行・詳細の extraInfo はオブジェクトか JSON 文字列） */
export function isStructureCalcCase(row) {
  let extra = row && row.extraInfo
  if (typeof extra === 'string') {
    try {
      extra = JSON.parse(extra)
    } catch (e) {
      extra = null
    }
  }
  return !!(extra && extra.requestType === 'structure_calc')
}

/**
 * 案件ステータスの表示名。段階は名前で出す（「基本設計 資料確認中」「構造計算 検収中」）。
 * row を渡すと第 1 段階を構造計算／基本設計で出し分け、渡さないとき（絞り込みの選択肢）は「基本設計・構造計算」。
 */
export function translateCaseStatus(vm, status, fallback = '-', row) {
  const raw = String(status || '').trim()
  if (!raw) return fallback
  const m = /^CASE_STAGE_([123])_(CONFIRMING|REVIEWING|IN_PROGRESS|PRODUCT_REQUESTING|COMPLETED)$/.exec(raw)
  if (!m) return callTranslate(vm, caseStatusKey(raw), fallback)
  const stageNo = Number(m[1])
  let stageKey = CASE_STAGE_TITLE_KEYS[stageNo]
  if (stageNo === 1) {
    if (row === undefined) stageKey = 'case.status.stage_basic_or_structure'
    else if (isStructureCalcCase(row)) stageKey = 'case.progress.stage_structure_calc'
  }
  const stage = callTranslate(vm, stageKey, '')
  const phase = callTranslate(vm, `case.status.phase_${m[2].toLowerCase()}`, '')
  if (!stage || !phase) return callTranslate(vm, caseStatusKey(raw), fallback)
  const format = callTranslate(vm, 'case.status.stage_phase', '{stage} {phase}')
  return format.replace('{stage}', stage).replace('{phase}', phase)
}

export function translateCasePriority(vm, priority) {
  return callTranslate(vm, casePriorityKey(priority), '-')
}

export function translateCaseBoolean(vm, value) {
  return callTranslate(vm, value ? 'case.boolean.yes' : 'case.boolean.no', value ? 'Yes' : 'No')
}

export function caseStatusOptions(vm) {
  return CASE_STATUS_VALUES.map((value) => ({
    value,
    label: translateCaseStatus(vm, value),
  }))
}

export function casePriorityOptions(vm) {
  return [
    { value: '0', label: translateCasePriority(vm, 0) },
    { value: '1', label: translateCasePriority(vm, 1) },
    { value: '2', label: translateCasePriority(vm, 2) },
  ]
}

const CASE_DOCUMENT_LABELS_JA = {
  quotation: '見積書',
  deliveryNote: '納品書',
  requestForm: '請求書',
}

const CASE_STAGE_LABELS_JA = {
  basic_design: '基本設計',
  application: '確認申請',
  detail_design: '実施設計',
}

export function buildCaseDocumentFilename(type, stageKey, projectName) {
  const documentLabel = CASE_DOCUMENT_LABELS_JA[type] || '書類'
  const stageLabel = CASE_STAGE_LABELS_JA[String(stageKey || '').trim()] || String(stageKey || '').trim()
  const project = String(projectName || '').trim()
  const parts = [documentLabel]
  if (stageLabel) parts.push(stageLabel)
  if (project) parts.push(project)
  return `${parts.join('_')}.pdf`
}
